import axios from 'axios';

const isLocal = typeof window !== 'undefined' && window.location.hostname === 'localhost';
export const AUTH_API_BASE_URL = process.env.REACT_APP_API_URL || (isLocal ? 'https://crm-tkxn.onrender.com/api' : 'https://crm-tkxn.onrender.com/api');
// export const LEADS_API_BASE_URL = process.env.REACT_APP_LEADS_API_URL || (isLocal ? 'http://localhost:5001/api' : 'http://localhost:5001/api');
export const LEADS_API_BASE_URL = process.env.REACT_APP_LEADS_API_URL || 'https://leadmgnt.onrender.com/api';
// Create axios instance for authentication
const authApi = axios.create({
  baseURL: AUTH_API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Create axios instance for leads data
const leadsApi = axios.create({
  baseURL: LEADS_API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Default export for backward compatibility (uses leads API)
const api = leadsApi;

// Request interceptor for auth API
authApi.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('authToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Request interceptor for leads API
leadsApi.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('authToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    } else {
      // For local development, bypass auth requirement
      config.headers['x-bypass-auth'] = 'true';
    }
    console.log('🔍 Making API call to:', config.baseURL + config.url);
    console.log('🔑 Token present:', !!token);
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle token expiration for both APIs
const responseInterceptor = (response) => response;
const errorInterceptor = (error) => {
  if (error.response?.status === 401) {
    // Token expired or invalid
    localStorage.removeItem('authToken');
    localStorage.removeItem('userInfo');
    window.location.href = '/login';
  }
  return Promise.reject(error);
};

authApi.interceptors.response.use(responseInterceptor, errorInterceptor);
leadsApi.interceptors.response.use(responseInterceptor, errorInterceptor);

export { authApi, leadsApi };
export default api;

// API endpoints (baseURL already includes /api)
export const API_ENDPOINTS = {
  // Authentication
  REGISTER_SUPERADMIN: '/auth/register-superadmin',
  LOGIN: '/auth/login',
  UPDATE_SUPERADMIN: (id) => `/auth/update-superadmin/${id}`,
  CHANGE_PASSWORD: '/auth/change-password',

  // Franchise
  FRANCHISES: '/franchises',
  FRANCHISE_BY_ID: (id) => `/franchises/${id}`,

  // Company
  COMPANIES: '/companies',
  COMPANY_BY_ID: (id) => `/companies/${id}`,

  // Employee
  EMPLOYEES: '/employees',
  EMPLOYEE_BY_ID: (id) => `/employees/${id}`,
  EMPLOYEES_BY_COMPANY: (companyId) => `/companies/${companyId}/employees`,

  // Business Profile
  BUSINESS_PROFILES: '/business-profiles',
  BUSINESS_PROFILE_BY_ID: (id) => `/business-profiles/${id}`,

  // Department
  DEPARTMENTS_BY_COMPANY: (companyId) => `/companies/${companyId}/departments`,
  DEPARTMENT_BY_ID: (id) => `/departments/${id}`,

  // Holiday
  HOLIDAYS_BY_COMPANY: (companyId) => `/companies/${companyId}/holidays`,
  HOLIDAY_BY_ID: (id) => `/holidays/${id}`,

  // Todos
  TODOS: '/todos',
  TODO_BY_ID: (id) => `/todos/${id}`,

  // Leads (External API Routes)
  LEADS: '/leads',
  LEAD_BY_ID: (id) => `/leads/${id}`,

  // Form Fields
  FORM_FIELDS: '/form-fields',
  FORM_FIELD_BY_ID: (id) => `/form-fields/${id}`,
};
